


























































































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractActsByContract } from "@/models/contract";
import Page from "@/components/for-page-grid/Page.vue";
import ContractActTable from "@/components/for-documents-view/ContractActTable.vue";
import ContractDocGetterDialog from "@/components/for-documents-view/ContractDocGetterDialog.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import {mapGetters, mapMutations} from "vuex";
import DocGetterMixin from "@/components/mixins/DocGetter.vue";
import XDialog from "@/components/SimpleDialog.vue";
import moment from "moment";

@Component({
  components: {
    Page,
    ContractActTable,
    ContractDocGetterDialog,
    XNotice,
    XDialog,
  },
  computed: {
    ...mapGetters("contract", { contractId: "id" }),
  },
  ...mapMutations("error", {
    setShowError: "setShow",
    setErrorMessage: "setMessage",
  }),
  data: () => ({
    requiredRule: [
      v => !!v || 'Заполните данное поле',
    ],
  }),
})
class ContractActsTabContent extends Mixins(AppApiMixin, DocGetterMixin) {
  documentList: ContractActsByContract[] = [];
  currentDocId = -1;
  currentDocName = '';
  currentDocStatus = -1;

  // Состояния всплывающих элементов страницы.
  showDocSendingDialog = false;
  useDocSendingDialogNotice = false;
  showDocSubscribeDialogNotice = false;
  targetEmail = "";

  showDocDownloadingDialog = false;

  declineDialog = false;
  declineDialogPrDeb = 0;
  declineDialogPrKr = 0;
  declineDialogPokDeb = 0;
  declineDialogPokKr = 0;
  declineDialogMessage = "";

  public mounted() {
    this.getDocData();
  }

  public getDocData(cache = true) {
    const { contractId } = this;

    this.getContractActsByContract(
      {contractId, cache},
      (documentList: ContractActsByContract[]) => {
        this.documentList = documentList;
      }
    );
  }

  public closeAllDialogs() {
    this.showDocSendingDialog = false;
    this.showDocDownloadingDialog = false;

    this.targetEmail = "";
    this.currentDocId = -1;
    this.currentDocName = "";

    // статус документа
    this.currentDocStatus = -1;
    this.declineDialog = false;
    this.declineDialogPrDeb = 0;
    this.declineDialogPrKr = 0;
    this.declineDialogPokDeb = 0;
    this.declineDialogPokKr = 0;
    this.declineDialogMessage = "";
  }

  public getDocName() {
    const doc = this.documentList.find((doc) => {
      return doc.документ === this.currentDocId;
    });
    return (doc?.["номер"] || '') + ' от ' + moment(doc?.["дата"] || '').format('DD.MM.YYYY');
  }
  public prepareDocData() {
    const doc = this.documentList.find((doc) => {
      return doc.документ === this.currentDocId;
    });

    this.declineDialogPrDeb = doc?.["суммадтпродавец"] || 0;
    this.declineDialogPrKr = doc?.["суммактпродавец"] || 0;
    this.declineDialogPokDeb = doc?.["суммадтпокупатель"] || 0;
    this.declineDialogPokKr = doc?.["суммактпокупатель"] || 0;
  }

  public setDocStatus() {
    this.setContractActStatus({
      documentId: this.currentDocId,
      contractId: this.contractId,
      status: this.currentDocStatus,
      pr_deb: this.declineDialogPrDeb,
      pr_kr: this.declineDialogPrKr,
      pok_deb: this.declineDialogPokDeb,
      pok_kr: this.declineDialogPokKr,
      message: this.declineDialogMessage,
    })
      .then((response) => {
        if (response.result) {
          if ((response?.data?.Ошибка || '') != "") {
            this.setErrorMessage(response.data.Ошибка);
            this.setShowError(true);
          } else {
            this.showDocSubscribeDialogNotice = true;
            this.getDocData(false);
          }
        }
      })
      .catch((_) => {
        this.setErrorMessage(_ || 'Ошибка изменения статуса документа');
      });
  }
}

export default ContractActsTabContent;
